module.exports = __webpack_public_path__ + "media/zinc-large.67a1fe6d.mp4";